import React, { FC } from "react";
import { PermissionKey } from "Shared/types/Employer";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import { usePermissionsVisualizerContext } from "Components/PermissionsVisualizer/permissions-visualizer-context";

type DPPermissionGateProps = {
  every?: boolean;
  fallback?: JSX.Element;
  permissionKeys: PermissionKey[];
};

const visualizationStyles = {
  outline: "2px solid green",
  padding: 4,
};

const DPPermissionGate: FC<DPPermissionGateProps> = ({
  children,
  every,
  fallback,
  permissionKeys = [],
}) => {
  const { isVisualizationOn } = usePermissionsVisualizerContext();
  const { loading, permissions } = usePartnerConfig();
  if (loading) {
    return null;
  }
  const hasPermission = (permissionKey: PermissionKey) =>
    !!permissions[permissionKey];
  if (!permissionKeys[every ? "every" : "some"](hasPermission)) {
    return fallback || null;
  }

  return (
    <>
      {isVisualizationOn ? (
        <Box style={visualizationStyles}>
          <Typography style={{ fontSize: 12, fontWeight: "bold" }}>
            {permissionKeys.toString()}
          </Typography>
          {children}
        </Box>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default DPPermissionGate;
